import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { BetreuerWorkDayAbsentLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';

interface BetreuerWorkDayAbsentProps {
    disabled: boolean;
    value: string;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    onChange: (newValue: string) => void;
}

export const BetreuerWorkDayAbsent: React.FC<BetreuerWorkDayAbsentProps> = ({
    value,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    onChange,
}) => {
    const options = React.useMemo(() => {
        const o = Object.keys(BetreuerWorkDayAbsentLabel).map((key) => ({
            value: key,
            label: BetreuerWorkDayAbsentLabel[key],
        }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [allowEmpty]);

    return (
        <>
            <Label>Abwesend</Label>
            <Select
                name="absent"
                isDisabled={disabled}
                value={
                    value
                        ? {
                              value,
                              label: BetreuerWorkDayAbsentLabel[value] || value,
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '');
                }}
            />
        </>
    );
};
